module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0653-min.329b93bb.jpg";